export default "__VITE_ASSET__DM_6tpy9__"